// extracted by mini-css-extract-plugin
export var cardHeader = "_fr-0";
export var reorderHandle = "_fr-3";
export var titleArea = "_fr-1";
export var titleAreaWithHandle = "_fr-2";